import { NOTIFICATIONS_PAGE } from "../../../utils/url/staticUrls";
import { redirectToUrl } from "../../../utils/url/urlUtils";
import { DateFormatType, formatDate } from "../../../utils/DateFormatter";
import { type NotificationDTO } from "../../../Notifications/api/dto";
import { type NotificationContext, Notifications } from "../../../Notifications/Messages";
import { Icon } from "~/common/components/icon/Icon";
import { IconType } from "~/common/components/icon/IconType";
import { type MouseEvent } from "react";
import { C_PRIMARY } from "~/common/components/icon/Colors";

interface NotificationItemProps {
  notification: NotificationDTO;
  readMessage: (item: NotificationDTO) => Promise<unknown>;
}

export const NotificationsItem = ({ notification, readMessage }: NotificationItemProps) => {
  const context: NotificationContext = {
    markAsRead: async (data) => {
      if (!data.read) {
        // TODO FIXME
        await readMessage(data as NotificationDTO);
      }
    },
  };

  const goToNotificationsPage = (notification: NotificationDTO) => async (e: MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const url = (e.target as HTMLElement).closest("a")?.getAttribute("href");
    await context.markAsRead(notification);
    if (url) {
      redirectToUrl(url);
    }
  };

  return (
    <a
      className={"scha__personal-nav__notifications-menu__list-item" + (notification.read ? "" : "__read")}
      href={NOTIFICATIONS_PAGE}
      onClick={goToNotificationsPage(notification)}
    >
      <div className={"scha__personal-nav__notifications-menu__list-item__block-text"}>
        <span className={"scha__personal-nav__notifications-menu__list-item__title-notification"}>
          {Notifications.renderTitle(notification, context)}
        </span>
        <span className={"scha__personal-nav__notifications-menu__list-item__text-notification"}>
          {Notifications.renderDescription(notification, context)}
        </span>
        <span className={"scha__personal-nav__notifications-menu__list-item__date-notification"}>
          {formatDate(new Date(notification.notificationDate), DateFormatType.DATE)}
        </span>
      </div>
      <div
        className={"scha__personal-nav__notifications-menu__list-item__envelope-btn"}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          readMessage(notification);
        }}
      >
        <Icon style={{ color: C_PRIMARY }} type={notification.read ? IconType.Envelope : IconType.EnvelopeOpen} />
      </div>
    </a>
  );
};
